import { ref } from 'vue'

import type SimpleAudioPlayer from '@/common/components/SimpleAudioPlayer.vue'

type SimpleAudioPlayerComponent = InstanceType<typeof SimpleAudioPlayer> & {
    toggle(): void
}

const useSimplePlayersSet = () => {
    const currentlyPlaying = ref<SimpleAudioPlayerComponent>()

    const onPlayerPaused = (): void => {
        currentlyPlaying.value = undefined
    }

    const onPlayerStarted = async (player: SimpleAudioPlayerComponent): Promise<void> => {
        await currentlyPlaying.value?.toggle()
        currentlyPlaying.value = player
    }

    return {
        onPlayerPaused,
        onPlayerStarted
    }
}

export {
    useSimplePlayersSet
}
